import { render, staticRenderFns } from "./UpcomingRenewals.vue?vue&type=template&id=2899b2ec&scoped=true"
import script from "./UpcomingRenewals.vue?vue&type=script&lang=js"
export * from "./UpcomingRenewals.vue?vue&type=script&lang=js"
import style0 from "./UpcomingRenewals.vue?vue&type=style&index=0&id=2899b2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899b2ec",
  null
  
)

export default component.exports